(function($) {

var AiicMap = {
  	mapElement: $('#map'),
    tooltip: $('#tooltip')[0],
    searchForm: $('.searchbar'),
	selectElement: $('.fieldset-city select'),
	isearchData: window.isearchData,
    startZoom: 6,
	maxZoom: 10,
	mapCenter: [],
	isMobile: false,
	locations: AiicThemeVars.regionLocations,
	mapFileUrl: AiicThemeVars.templateDir + '/dist/vendor/maps/' + AiicThemeVars.regionKey + '.json',
	mapSettings: [
		{ regionKey: 'germany', center: [10.5, 51.5] },
		{ regionKey: 'switzerland', center: [8.1, 46.8], startZoom: 8, maxZoom: 12 },
		{ regionKey: 'france', center: [2.2, 46.6] },
		{ regionKey: 'italy', center: [12.833333, 42.833333] },
		{ regionKey: 'africa', center: [16, 2.5], startZoom: 3.4, maxZoom: 12 },
		{ regionKey: 'asiapacific', center: [109.29, 9.62], startZoom: 2.75, maxZoom: 12 },
	],

    init: function() {
      	this.checkMobile();
      	this.initMap();

		this.prepareISearchData();
		this.addFeatures();

		this.initializeMapEventListener();
		this.initializeEventListener();

		this.addResultsData();
    },

  	checkMobile: function() {
	    if($(window).width() > 768){
	    	this.isMobile = false;
	    } else {
	      	this.isMobile = true;
	    }
	},

    initMap: function () {
		var that = this;
		var regionSettings = _.find(that.mapSettings, { 'regionKey': AiicThemeVars.regionKey  } );

		if(regionSettings.startZoom) {
			that.startZoom = regionSettings.startZoom;
		}

		if(regionSettings.maxZoom) {
			that.maxZoom = regionSettings.maxZoom;
		}

		if(regionSettings.center) {
			that.mapCenter = regionSettings.center;
		}

    	var styleVars = {
    		// iconSize: [23.657,34.922],
    		iconSize: [24,35],
    		iconAnchor: [0.5, 1],
    		iconScale: 0.85,
    		textFont: '12px sans-serif',
    		textColor: '#555555',
    		resultFont: '12px sans-serif',
    		resultColor: '#FFFFFF',
    		brandPrimaryColor: '#029BC4',
    		brandSecondaryColor: '#ed8029'
		};

      	this.resultStyleFunc = (function() {
	    	var style = new ol.style.Style({
		        text: new ol.style.Text({
		            text: '',
		            font: styleVars.resultFont,
		            fill: new ol.style.Fill({
		                color: styleVars.resultColor
		            }),
		            offsetY: -21
		        })
	    	});

			var styles = [style];

			return function(feature, resolution) {
	    		style.getText().setText(feature.get("name"));

	    		if(feature.get('id') === that.currentSelection) {
	    			style.setImage(new ol.style.Icon({
		            	src: AiicThemeVars.templateDir + '/dist/images/pin-orange-full.svg',
						// size: styleVars.iconSize,
						imgSize: styleVars.iconSize,
	            		anchor: styleVars.iconAnchor,
	            		// scale: 0.9
		        		})
	    			);
	    		} else {
	    			style.setImage(new ol.style.Icon({
		            	src: AiicThemeVars.templateDir + '/dist/images/pin-green-full.svg',
						// size: styleVars.iconSize,
						imgSize: styleVars.iconSize,
	            		anchor: styleVars.iconAnchor,
	            		// scale: 0.9
		        		})
	    			);
	    		}
	    		return styles;
	    	};
	    })();

      	this.defaultStyleFunc = (function() {
	    	var style = new ol.style.Style({
	    		image: new ol.style.Icon({
		            src: AiicThemeVars.templateDir + '/dist/images/pin-blue.svg',
					imgSize: styleVars.iconSize,
	            	anchor: styleVars.iconAnchor,
	            	// scale: styleVars.iconScale
		        }),
		        text: new ol.style.Text({
		            text: '',
		            font: styleVars.textFont,
		            fill: new ol.style.Fill({
		                color: styleVars.textColor
		            }),
		            offsetY: 5
		        })
	    	});
	    	var styles = [style];
	    	return function(feature, resolution) {
	    		style.getText().setText(feature.get("name"));
	    		return styles;
	    	};
	    })();

      	this.selectedStyleFunc = (function() {
	    	var style = new ol.style.Style({
	    		image: new ol.style.Icon({
		            src: AiicThemeVars.templateDir + '/dist/images/pin-orange.svg',
					// size: styleVars.iconSize,
					imgSize: styleVars.iconSize,
	            	anchor: styleVars.iconAnchor,
	            	// scale: styleVars.iconScale
		        }),
		        text: new ol.style.Text({
		            text: '',
		            font: styleVars.textFont,
		            fill: new ol.style.Fill({
		                color: styleVars.textColor
		            }),
		            offsetY: 5
		        })
	    	});
	    	var styles = [style];
	    	return function(feature, resolution) {
	    		style.getText().setText(feature.get("name"));
	    		return styles;
	    	};
	    })();

	    //Default pins
     	this.vectorSource = new ol.source.Vector({});
      	this.vectorLayer = new ol.layer.Vector({
        	source: this.vectorSource,
        	style: this.defaultStyleFunc
      	});

      	//Result pins
		this.resultSource = new ol.source.Vector({});
      	this.resultsLayer = new ol.layer.Vector({
        	source: this.resultSource,
        	style: this.resultStyleFunc
      	});

      	this.vectorMapLayer = new ol.layer.Vector({
          	source: new ol.source.Vector({
              	url: this.mapFileUrl,
              	format: new ol.format.GeoJSON()
          	}),
          	style: function(feature, resolution) {
				var isDisabled = false;

				if (feature.get('ADM0_A3') !== undefined) {
					var countryCodes = Object.keys(AiicThemeVars.region.countries);

					if(	countryCodes.indexOf(feature.get('ADM0_A3')) < 0 ) {
						isDisabled = true;
					}
				}

              	return new ol.style.Style({
                	fill: new ol.style.Fill({
                    	color: isDisabled ? '#f1f1f1' : '#CCCCCC'
                	}),
                	stroke: new ol.style.Stroke({
                    	color: '#ffffff',
                      	width: 1
                  	})
              	});
          	}
      	});

      	this.view = new ol.View({
			center: ol.proj.transform( that.mapCenter, 'EPSG:4326', 'EPSG:3857'),
			zoom: this.isMobile ? 5.5 : this.startZoom,
			minZoom: this.startZoom,
			maxZoom: this.maxZoom
      	});

      	this.map = new ol.Map({
			interactions: ol.interaction.defaults({mouseWheelZoom:false}),
			target: 'map',
			layers: [
				// new ol.layer.Tile({
				//   source: new ol.source.OSM()
				// }),
				this.vectorMapLayer,
				this.vectorLayer,
				this.resultsLayer
        	],
        	view: this.view
      	});

      	this.tooltipOverlay = new ol.Overlay({
        	element: this.tooltip,
        	offset: [10, 0],
        	positioning: 'bottom-left'
      	});

      	this.map.addOverlay(this.tooltipOverlay);
    },

    prepareISearchData: function() {
    	if(_.has(this.isearchData, 'locations')) {
   	    	_.forEach(this.isearchData.locations, function(value, key){
	    		value.id = value.id.toString();
	    	});
    	}
    },

    addFeatures: function() {
		var locationFeatures = [];
		for (var i = 0; i < this.locations.length; i++) {
			var location = this.locations[i];

			//Only add features for locations that are on the isearchData.locations list
			if(_.find(this.isearchData.locations, { 'id': location.id } ) || !AiicThemeVars.isearchEnabled) {

				if(location.lng && location.lat) {
					var loc = [parseFloat(location.lng), parseFloat(location.lat)];

					var feature = new ol.Feature({
						selectable: true,
						id: location.id,
						name: location.name,
						class: 'default',
						type: 'point',
						loc: loc,
						geometry: new ol.geom.Point(new ol.proj.fromLonLat(loc)),
						link: location.link,
					});

					locationFeatures.push(feature);
				}
			}
		}

		//Update map
		if(locationFeatures.length) {
			this.vectorSource.addFeatures(locationFeatures);
			// this.centerMap();
		} else {
			console.warn('AIIC: No locations found to display on map.');
		}

		//Set currently selected marker
		this.currentSelection = this.selectElement.val();
		if(this.currentSelection){
			this.setMarkerHighlight(this.currentSelection);
		}
    },

    initializeMapEventListener: function() {
      	var that = this;

      	this.map.on('pointermove', function(event) {
          	var pixel = that.map.getEventPixel(event.originalEvent);
			var overFeature = false;
			var showTooltip = false;
			var tooltipText = '';

			that.map.forEachFeatureAtPixel(pixel, function(feature, layer) {
				// name is used in the GeoJSON files that contains states (DE,FR,IT,CH)
				// NAME is used in the GEOJSON files that only contain countries (AF, AP)
				var name = feature.get('name') || feature.get('NAME');
			    if (name) {
			        that.tooltipOverlay.setPosition(event.coordinate);
					tooltipText = name;
			        showTooltip = true;
			    }

			    // stop at first selectable
			    if (feature.get('selectable') === true) {
			        overFeature = true;
			        return true;
			    }
			});


          	that.map.getTargetElement().style.cursor = overFeature ? 'pointer' : '';

          	if(showTooltip) {
              	that.tooltip.innerHTML = tooltipText;
              	$(that.tooltip).addClass('is-visible');
          	} else {
              	$(that.tooltip).attr('class', '');
          	}
      	});

      	this.map.on('singleclick', function(event) {
        	that.map.forEachFeatureAtPixel(event.pixel, function(feature, layer){
          		var id = feature.get('id');
          		if(id) {
					that.setMarkerHighlight(id);

					if(AiicThemeVars.isearchEnabled) {
						// that.zoomIntoLocation(feature);
						that.selectElement.val(id).trigger('change', { selected: id }).trigger('chosen:updated');
						that.mapElement.addClass('is-waiting');
						that.searchForm.submit();
					} else {
						if(feature.get('link') !== '') {
							window.location.href = feature.get('link');
						}
					}
          		}
          		else {
					var state = feature.get('name');
	            	if (state){
	            		var geometry = feature.getGeometry();
						// that.animateToExtent(geometry.getExtent());
	            	}
          		}

          		return true;
        	});
      	});
    },

	initializeEventListener: function() {
		var that = this;

		this.selectElement.on('change', function(event, params) {
			if(params.selected !== ''){
				// console.log(params.selected);
				this.currentSelection = params.selected;
				that.setMarkerHighlight(params.selected);
			} else {
				that.resetMarkerHighlight();
			}
		});
	},

    centerMap: function() {
     	var coordinates = [];
      	var center = [];

      	this.locations.forEach(function(location) {
        	var loc = [parseFloat(location.lng), parseFloat(location.lat)];
        	coordinates.push(loc);
      	});

      	var extent = new ol.extent.boundingExtent(coordinates);
      	center = ol.extent.getCenter(extent);

      	this.centerOfLocations = center;

	  	this.view.setCenter(ol.proj.fromLonLat(center));
    },

    animateToExtent: function(extent) {
		this.map.getView().fit(extent, this.map.getSize(), {
            duration: 2000
        });
    },

    zoomIntoLocation: function(feature) {
    	var that = this;
      	this.view.animate({
        	center: ol.proj.fromLonLat(feature.get('loc')),
        	zoom: that.startZoom + 1,
        	duration: 2000
      	});
    },

    resetMarkerHighlight: function() {
	  	var features = this.vectorSource.getFeatures();
      	features.forEach(function(feature) {
        	feature.setStyle(this.defaultStyleFunc);
      	});

      	this.resultSource.clear();
    },

    setMarkerHighlight: function(id) {
    	// console.log('set marker setMarkerHighlight: ', id);
      	this.resetMarkerHighlight();

      	var features = this.vectorSource.getFeatures();
      	var selected = '';

      	features.forEach(function(feature) {
        	if(feature.get('id') === id) {
            	selected = feature;
          	}
      	});

      	if(selected) {
          	selected.setStyle(this.selectedStyleFunc);
      	}
    },

    addResultsData: function() {
    	var that = this;
    	var results = [];

    	if(this.isearchData.results && this.locations.length) {
    		_.each(that.isearchData.results, function(value, key) {
    			//Find id of key
    			var found = _.find(that.isearchData.locations, { 'name' : key });

    			// Get location data with coords
				var location = _.find(that.locations, { 'id': found.id });
				if (location) {
					location.count = value.toString();
					results.push(location);
				}
    		});

    		this.addResultFeature(results);
    	}
    },

	addResultFeature: function(results) {
		var resultFeatures = [];

		for (var i = 0; i < results.length; i++) {
			var location = results[i];

			if(location.lng && location.lat) {
				var loc = [parseFloat(location.lng), parseFloat(location.lat)];
				var feature = new ol.Feature({
					selectable: false,
					id: location.id,
					name: location.count,
					type: 'point',
					loc: loc,
					geometry: new ol.geom.Point(new ol.proj.fromLonLat(loc))
				});

				resultFeatures.push(feature);
			}
		}

		// Update map
		if(resultFeatures.length) {
			this.resultSource.addFeatures(resultFeatures);
		} else {
			console.info('No results found to display on map.');
		}
    }

};

$(document).ready(function() {
    // Start Programm
    AiicMap.init();
});



})(jQuery); // Fully reference jQuery after this point.
